<template>
  <div>
    <div v-if="!dataLoaded">
      <v-progress-circular indeterminate color="primary" class="ret-center-absolute"></v-progress-circular>
    </div>
    <div v-if="dataLoaded">
      <v-card class="ret-card">
        <v-card-title>
          <h3 class="headline">{{ $tc('products.entity-name', 1) }}</h3>
          <v-spacer></v-spacer>
          <v-btn v-if="editedItem.id" text color="warn" @click="onDestroy(item)" data-test="product-archive">{{ $t('archive') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <form>
            <v-text-field
              v-model="editedItem.name"
              :label="$t('name')"
              data-test="new-product-name"
            ></v-text-field>
            <v-select
              v-model="editedItem.category"
              :items="categoryIndex"
              :label="$t('category')"
              :menu-props="{bottom: true}"
              data-test="new-product-category"
            ></v-select>
            <v-text-field
              v-model="editedItem.price"
              :label="$t('price')"
              type="number"
              step=".01"
              data-test="new-product-price"
            ></v-text-field>
            <v-btn @click="$router.go(-1)">{{ $t('back') }}</v-btn>
            <v-btn
              @click="handleSaveClick"
              color="primary"
              :disabled="!isUnsaved"
              data-test="new-product-save"
            >{{ $t('save') }}</v-btn>
          </form>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import displayHelpers from '../helpers/display-helpers.es6'
import itemHelpers from '../helpers/item-helpers.es6'

export default {
  name: 'product',
  mixins: [displayHelpers, itemHelpers],
  data: function () {
    return {
      model: { name: 'products' },
      categoryIndex: [
        { text: this.$t('products.category.material'), value: 'material' },
        { text: this.$t('products.category.work'), value: 'work' }
      ]
    }
  }
}
</script>
